import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/axiosAuth";

export const fetchActiveProducts = createAsyncThunk(
  "activeProducts/fetchRows",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`/api/ActiveProducts`);
      return { rows: response.data.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const activeProductsSlice = createSlice({
  name: "activeProducts",
  initialState: {
    data: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchActiveProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchActiveProducts.fulfilled, (state, action) => {
        const { rows } = action.payload;
        state.data = rows;
        state.status = "succeeded";
      })
      .addCase(fetchActiveProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const selectActiveProductsRows = (state) => state.ActiveProducts.data;
export const selectActiveProductsStatus = (state) =>
  state.ActiveProducts.status || "idle";
export const selectActiveProductsError = (state) =>
  state.ActiveProducts.error || null;
export const selectAvailableInPOS = (state) =>
  state.activeProducts.data.filter((product) => product.available_in_pos);
export const selectPriorityProducts = (state) =>
  state.activeProducts.data.filter((product) => product.priority);

export default activeProductsSlice.reducer;
